import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AuthContractsComponent } from "./auth-contracts.component";

import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatRadioModule } from "@angular/material/radio";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { CommonModule } from "@angular/common";
import { NgxWebstorageModule } from "ngx-webstorage";
import { secret } from "app/app.env";
import { LoginService } from "../login.service";
import { AuthContractsService } from "./auth-contracts.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    FlexLayoutModule,
    MatListModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatGridListModule,
    MatChipsModule,
    MatRadioModule,
    MatTabsModule,
    MatToolbarModule,
    MatTableModule,
    MatProgressBarModule,
    MatInputModule,
    MatCardModule,
    MatCheckboxModule,
    MatIconModule,
    MatMenuModule,
    MatSnackBarModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatGridListModule,
    MatChipsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatTabsModule,
    MatInputModule,
    MatProgressBarModule,
    MatToolbarModule,
    MatTableModule,
    MatDialogModule,
    MatGridListModule,
    MatListModule,
    FormsModule,
    ReactiveFormsModule,
    NgxWebstorageModule.forRoot({
      prefix: secret.tsDebtor,
      separator: "",
      caseSensitive: false
    })
  ],
  exports: [AuthContractsComponent],
  declarations: [AuthContractsComponent],
  providers: [AuthContractsService, LoginService],
  entryComponents: [AuthContractsComponent]
})
export class AuthContractsModule {}
